import * as Sentry from "@sentry/browser";

export const isDebugMode =
  import.meta.env.RAILS_ENV != 'production'
if (isDebugMode)
  console.log('DEBUG-MODE')

const isSentryLogged = ['production', 'stage_minor', 'stage_major'].includes(
  import.meta.env.RAILS_ENV)

export const debugLog = (...args) => {
  if (isDebugMode) {
    console.log(...args)
  }
}

export const errorLog = (...args) => {
  if (isDebugMode) {
    console.error(...args)
  }

  if (isSentryLogged) {
    // optionally specify the severity level:
    // "fatal" | "error" | "warning" | "log" | "debug" | "info" (default)
    Sentry.captureMessage(args.flat(), "error");
  }
}